import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from "reactstrap";
import axios from "axios";

const EditUserModal = ({ isOpen, toggle, user, onSaved }) => {
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phone, setPhone] = useState("");

    useEffect(() => {
        if (user) {
            setName(user.user_NAME || "");
            setSurname(user.user_SURNAME || "");
            setPhone(user.user_PHONE || "");

        }
    }, [user]);

    const handleSave = async () => {
        try {
            await axios.put("/api/user/update", {
                user_ID: user.user_ID,
                user_SURNAME: surname,
                user_NAME: name,
                user_PHONE: phone,

            }, { withCredentials: true });

            onSaved();  // rafraîchir la liste des casques
            toggle();   // fermer la modal
        } catch (err) {
            console.error(err.response?.data || err);
        }
    };


    if (!user) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Modifier l'utilisateur</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Nom de famille</Label>
                    <Input type="text" value={surname} onChange={e => setSurname(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>Prénom</Label>
                    <Input type="text" value={name} onChange={e => setName(e.target.value)} />
                </FormGroup>
                <FormGroup>
                    <Label>Numéro de téléphone</Label>
                    <Input type="text" value={phone} onChange={e => setPhone(e.target.value)} />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Annuler</Button>
                <Button color="primary" onClick={handleSave}>Enregistrer</Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditUserModal;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license
